const endpoints = {
    AUTOCOMPLETE: "items/autocomplete",
    AUTOCOMPLETE_FACETS: "items/autocomplete_facets",
    BIDDER: "filters/autocomplete",
    ITEMS: "items/list",
    ITEMS_FACETS: "items/facets",
    ALL_FACETS: "items/all_facets",
	GENERATE_FILE: "files/generate_file",
    GET_FILE: "files/get_file",
    DELETE_FILE: "files/delete_file",
    GET_USER_FILES: "files/list_all",
    CHARTS: "charts",
    GET_USERS: "users/get_user",
    DELETE_USER: "users/delete_user",
    CREATE_EDIT_USER: "users/create_edit_user",
    USER_PERMISSIONS: "users/get_user_permissions",
    GET_LOG: "logs/get_log",
    AUTOCOMPLETE_OVERPRICE: 'overpricing/autocomplete',
    ITEMS_OVERPRICE: 'overpricing/list',
    LIST_YEARS: 'filters/years'

}

export default endpoints;
